import LocationCityIcon from "@mui/icons-material/LocationCity";
import { SpecialistServicePath } from "utils/constants";
import permissions from "app/permissions";
import ListTrainingBuildings from "./List";
import CreateTrainingBuildings from "./Create";

export const resources = {
  isMenu: true,
  icon: <LocationCityIcon />,
  name: SpecialistServicePath + "training-buildings",
  title: "Учебни бази",
  list: <ListTrainingBuildings />,
  create: <CreateTrainingBuildings />,
  permission: permissions.canPreviewSpecialistsTrainingBuildings,
  createPermission: permissions.canManageSpecialistsTrainingBuildings,
};
